import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

interface DeviceReloadManagerProps {
  municipalityId: string;
  enabled: boolean;
}

const RELOAD_POLL_INTERVAL_MS = 5000;

export const DeviceReloadManager = ({
  municipalityId,
  enabled,
}: DeviceReloadManagerProps) => {
  const lastReloadTokenRef = useRef<number | null | undefined>(undefined);

  useEffect(() => {
    lastReloadTokenRef.current = undefined;
    if (!enabled || !municipalityId) return;

    let cancelled = false;

    const checkReloadState = async () => {
      try {
        const { reloadToken } = await api.municipalities.getReloadState(
          municipalityId,
        );
        if (cancelled) return;

        if (lastReloadTokenRef.current === undefined) {
          lastReloadTokenRef.current = reloadToken;
          return;
        }

        if (lastReloadTokenRef.current !== reloadToken) {
          window.location.reload();
        }
      } catch (error) {
        console.warn("[device-reload] No se pudo consultar la señal", error);
      }
    };

    void checkReloadState();
    const interval = window.setInterval(
      checkReloadState,
      RELOAD_POLL_INTERVAL_MS,
    );

    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, [enabled, municipalityId]);

  return null;
};
